/* MARMOT: shell – хедър логика (Фаза А2, Порция 4). Vanilla, defer.
   1) sticky сянка/полупрозрачност при скрол (клас is-stuck);
   2) мобилен бургер панел: отваряне/затваряне с X, Esc, клик извън;
      aria-expanded + скромен focus trap без библиотеки. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.marmotInit === '1') return;
    root.dataset.marmotInit = '1';

    // Sticky състояние
    var onScroll = function () {
      root.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Бургер панел
    var burger = root.querySelector('[data-marmot-burger]');
    var panel = root.querySelector('[data-marmot-panel]');
    var overlay = root.querySelector('[data-marmot-overlay]');
    var closeBtn = root.querySelector('[data-marmot-close]');
    if (!burger || !panel || !overlay) return;

    var open = false;

    function setOpen(next) {
      open = next;
      burger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      overlay.hidden = !open;
      document.documentElement.classList.toggle('marmot-menu-open', open);
      if (open) {
        var first = panel.querySelector('a, button');
        if (first) first.focus();
      } else {
        burger.focus();
      }
    }

    burger.addEventListener('click', function () { setOpen(!open); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    overlay.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      // Скромен focus trap: Tab циклира в панела.
      if (e.key === 'Tab') {
        var focusables = panel.querySelectorAll('a, button');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-marmot-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
